import { Space, Typography } from "antd";
import { useState } from "react";
import { Icon } from '@iconify/react';

export function InfoItem(props) {
    const { Paragraph } = Typography;
    const { title, info, editable = false } = props
    const [editableStr, setEditableStr] = useState(info);
    const onChange = (editVal) => {
        console.log(editVal)
        setEditableStr(editVal);
    };

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Space >
                    <Typography.Title level={4} style={{ margin: 0, color: "var(--color-white)" }}>{title} </Typography.Title>
                </Space>
                <Paragraph
                    editable={editable ? {
                        onChange: onChange,
                        icon: <Icon fontSize={24} icon="mdi:border-color" color="var(--color-white)" />,
                        enterIcon: false,
                        autoSize: false,
                    } : false}
                    style={{ color: "var(--color-white)", margin: 0, display: "flex" }}
                >
                    {editableStr}
                </Paragraph>
                <Space >

                </Space>
            </div>
        </>
    )
}
